import React from "react";

import type { ProcessedPickemSelection } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { OutcomeIcon } from "@/features/shell/components/shared/OutcomeIcon";

import * as styles from "./PickIcon.module.scss";

type PickemIconProps = {
  pick: Partial<ProcessedPickemSelection>;
  className?: string;
};

const PickemIcon = ({ pick, className }: PickemIconProps) => (
  <OutcomeIcon
    className={cx(styles.outcomeIcon, className)}
    outcomeType={pick.outcomeType}
    competitor={pick.competitor ?? undefined}
    silksUrl={pick?.event?.attributes?.silksUrl}
    reserveAvatarSpace
  />
);

export { PickemIcon };
